import React from 'react';
import { Typography } from '@mui/material';
import { ModalType } from 'entities/modal/model';
import { ECOSYSTEM_LINKS, Icons, ModalSidebar } from 'shared';

export interface Tap2MineModalPayload {
  data?: null;
  type: ModalType.Tap2Mine;
  isOpen?: boolean;
}

export const Tap2MineModal = React.forwardRef<
  HTMLElement,
  Pick<Tap2MineModalPayload, 'data' | 'isOpen'> & { onClose: VoidFunction }
>(({ onClose, isOpen }, ref) => {
  return (
    <ModalSidebar
      isOpen={isOpen}
      ref={ref}
      onClose={onClose}
      title={
        <>
          Tap-2-Mine
          <br />
          (PoI Mining)
        </>
      }
      subtitle="Earn from Your Phone, No Hardware Needed"
      icon={<Icons.HammerDark />}
      link={{
        title: 'Start Minting $CRAT',
        link: {
          href: ECOSYSTEM_LINKS.tap2mine,
          text: ECOSYSTEM_LINKS.tap2mine,
        },
      }}
    >
      <Typography variant="inherit" color="inherit" fontFamily="inherit">
        Tap-2-Mine is CratD2C’s gamified mining app.
      </Typography>
      <br />
      <Typography variant="inherit" color="inherit" fontFamily="inherit">
        Instead of buying expensive mining hardware, users can earn $CRAT (and related tokens) just by tapping,
        engaging, and completing simple in-app tasks.
      </Typography>
      <br />
      <Typography variant="inherit" color="inherit" fontFamily="inherit">
        It’s called Proof of Interaction (PoI) - rewarding real user activity and making mining accessible to anyone
        with a smartphone.
      </Typography>
    </ModalSidebar>
  );
});
